import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=491d16c8&"
import script from "./adminList.vue?vue&type=script&lang=ts&"
export * from "./adminList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports